import { h } from 'preact';
import { useLayoutEffect, useState, useRef } from 'preact/hooks';

export function onLazy(cb) {
  if (cb === false) lazyHandlers.splice(0, lazyHandlers.length);
  else if (typeof cb === 'function') lazyHandlers.push(cb);
}
const lazyHandlers = [];

export const lazy = function({ render, elements, tag = 'div' }) {
  const [load, setLoad] = useState(false);
  if (load && load.resolve) load.resolve(true);
  const ref = useRef(null);
  if (elements?.find(x => x.lazy === false)) {
    setLoad(true);
    console.log('forcing load', elements.length, elements[0].attrs.iTex);
  }
  useLayoutEffect(() => observe(ref, load, setLoad), [load]);
  let contents = () => h(tag, { style: { height: '120vh' } }, 'loading...');
  if (load) contents = () => elements.map(x => render(x));
  if (load || window.loadAll) {
    const it1 = elements[0].attrs.iTex;
    console.log('render', load, it1);
    if (load) lazyHandlers.map(x => x(it1));
  }
  return h('div', { ref, class: 'lazy' }, contents());
  // return h(Fragment, null, );
};

function observe(ref, load, setLoad) {
  const el = ref.current;
  if (load && load.el) {
    load.el.scrollIntoView();
    if (load.pos) window.scrollBy({ top: load.pos });
    return;
  } else if (load) {
    el.promLoad = null;
    return;
  }

  if (!el || !el.parentElement) return;
  const promLoad = () => new Promise(resolve => {
    // console.log('create promise', resolve);
    setLoad({ resolve });
  });
  el.promLoad = promLoad;
  const options = {};// { root: el.parentElement, threshold: 0 };
  function callback(e) {
    const e0 = e.find(x => x.isIntersecting && x.intersectionRatio > 0);
    if (!e0) return;
    if (e0.boundingClientRect.top < 0) {
      setLoad({
        el: e0.target.nextElementSibling,
        pos: e0.boundingClientRect.bottom,
      });
    } else setLoad(true);
    observer.disconnect();
  }
  /* global IntersectionObserver */
  const observer = new IntersectionObserver(callback, options);
  observer.observe(el);
  return () => observer.disconnect();
}
